import { Button, Theme, withStyles } from '@material-ui/core'
import i18next from 'i18next'
import { ComponentType } from 'react'
import { MuiClasses } from '../../types'

const styles = ({ spacing }: Theme) => ({
  button: {
    marginTop: spacing(),
    fontWeight: 400
  }
})

interface DeleteFormButtonProps {
  submitting: boolean
  label?: string
  classes: MuiClasses
  disabled?: boolean
  icon?: ComponentType
  variant?: 'outlined' | 'contained'
  textColor?: string
  borderRadius?: string
  fullWidth?: boolean
  handleClick: () => void
}

/** default label is 'general.submit' */
const DeleteFormButton = ({
  submitting,
  label,
  classes,
  disabled,
  variant = 'outlined',
  icon: Icon,
  textColor,
  fullWidth = false,
  borderRadius,
  handleClick
}: DeleteFormButtonProps) => {
  return (
    <Button
      onClick={() => handleClick()}
      className={classes.button}
      type='submit'
      variant={variant}
      color='secondary'
      fullWidth={fullWidth}
      disabled={submitting || disabled}
      style={{
        color: textColor ? textColor : '#000',
        borderRadius: borderRadius ? borderRadius : '10px'
      }}
    >
      {Icon && <Icon />}
      {i18next.t(
        label ? label : disabled ? 'general.confirmed' : 'general.confirm'
      )}
    </Button>
  )
}

export default withStyles(styles)(DeleteFormButton)
